import { useState, useContext } from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearPublicacion from "../elementos/complejos/FormCrearPublicacion";
import FormEditarPublicacion from "../elementos/complejos/FormEditarPublicacion";
import { UsuarioContext } from "../providers/personaContext";
const GestorPublicacion = ({ crear }) => {

const { persona } = useContext(UsuarioContext);

  return (
    <>
        <ContenedorPrincipal formaform="true"  >

        { crear ?
          <FormCrearPublicacion 
          usuarioLogueado={persona}
          />
          :
          <FormEditarPublicacion
          usuarioLogueado={persona}
          />
        }
          

        </ContenedorPrincipal>
    </>
  );
}

export default GestorPublicacion;